import React, { useCallback, useRef, useState } from 'react';
import { createPortal } from 'react-dom';

/**
 * Tooltip em portal (fixed) — escapa overflow/sticky da tabela.
 */
export default function UcHoverTooltipHost({
  tooltip,
  as: Comp = 'span',
  className,
  children,
  onMouseEnter,
  onMouseLeave,
  onFocus,
  onBlur,
  ...rest
}) {
  const ref = useRef(null);
  const [box, setBox] = useState(null);

  const show = useCallback(() => {
    if (!tooltip || !ref.current) return;
    const r = ref.current.getBoundingClientRect();
    setBox({ top: r.top - 6, left: r.right, text: tooltip });
  }, [tooltip]);

  const hide = useCallback(() => setBox(null), []);

  return (
    <>
      <Comp
        ref={ref}
        className={className}
        onMouseEnter={(e) => {
          onMouseEnter?.(e);
          show();
        }}
        onMouseLeave={(e) => {
          onMouseLeave?.(e);
          hide();
        }}
        onFocus={(e) => {
          onFocus?.(e);
          show();
        }}
        onBlur={(e) => {
          onBlur?.(e);
          hide();
        }}
        {...rest}
      >
        {children}
      </Comp>
      {box && typeof document !== 'undefined'
        ? createPortal(
            <span
              className="uc-hover-tooltip-portal"
              role="tooltip"
              style={{ top: box.top, left: box.left }}
            >
              {box.text}
            </span>,
            document.body
          )
        : null}
    </>
  );
}
